<template>
  <div v-if="user">
    <div class="row">
      <div class="col">
        <h1>
          {{ user.name }}
          <router-link
            class="btn btn-primary btn-sm pull-right"
            :to="`/users/${user._id}/edit`"
            v-if="isAdmin"
            >Edit</router-link
          >
        </h1>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col col-lg-4 text-center">
        <img class="img-fluid" :src="user.image" />
        <p>
          <span
            v-for="role in user.roles"
            :key="role"
            class="badge badge-dark"
            >{{ role.toUpperCase() }}</span
          >
        </p>
      </div>
      <div class="col col-lg-8">
        <p v-if="isAdmin && user.email">
          <strong>Email:</strong>
          {{ user.email }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import EzBadges from "@/components/shared/_VueEzBadges";

export default {
  name: "user-detail",
  components: {
    EzBadges
  },
  props: ["id"],
  watch: {
    $route: "getData"
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      user: state => state.users.current
    })
  },
  methods: {
    ...mapActions({
      usersProfile: "users/profile"
    }),
    async getData() {
      try {
        await this.usersProfile({ id: this.$route.params.id });
        this.$embers.pageData(this.user.name, this.user.summary);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h6 {
  margin: 0;
}
.indent {
  margin-bottom: 0.5em;
}
</style>
